import { Button } from '@mantine/core';
import { IconListDetails } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import { ImportTasksDrawer } from '@/pages/NewAdminConsole/components/ImportTasksDrawer';
import { usePermissionControl } from '@/pages/NewAdminConsole/hooks/usePermissionControl';

interface Props {
  opened: boolean;
  onOpen: () => void;
  onClose: () => void;
}

export const ImportTasksButton = ({ opened, onOpen, onClose }: Props) => {
  const { t } = useTranslation();
  const permissionControl = usePermissionControl();

  if (!permissionControl.canCreateUser()) return null;

  return (
    <>
      <Button size="sm" variant="default" leftSection={<IconListDetails size={16} />} onClick={onOpen}>
        {t('adminConsole.newConsole.import.tasks.buttonLabel')}
      </Button>
      <ImportTasksDrawer opened={opened} onClose={onClose} />
    </>
  );
};
